import React from "react";
import { Link } from "react-router-dom";
import "./coach-landing.css";

export default function CoachLandingComparison() {
  // Cifras de la página de tarifas de Harbiz (harbiz.io/tarifas), consultadas el
  // 1-oct-2026. Hasta ese día había dos filas que no se sostenían: «Permanencia
  // 3-12 meses» (Harbiz no tiene permanencia) y «Ingresos por referidos», que
  // promete dinero al coach (prohibido). Solo cosas comprobables.
  const comparisons = [
    { feature: "Precio para el profesional", other: "De 14 a 199 €/mes", wayo: "GRATIS" },
    { feature: "Límite de clientes", other: "5 o 50, según el plan", wayo: "Sin límite" },
    { feature: "El precio sube cuando creces", other: "Sí, por tramos de clientes", wayo: "No, nunca" },
    { feature: "IA de nutrición", other: "Extra «Nutri AI»: +14,99 €/mes", wayo: "✓ Incluido" },
    { feature: "Biblioteca de vídeos de ejercicios", other: "Extra «Video Library»: +19,99 €/mes", wayo: "✓ Incluido" },
    { feature: "Panel de gestión de clientes", other: "✓", wayo: "✓ Incluido" },
    { feature: "Permanencia", other: "Sin permanencia", wayo: "Sin permanencia" }
  ];

  return (
    <section className="compare-section">
      <div className="container">
        <div className="compare-header">
          <div className="section-tag">La diferencia</div>
          <h2 className="section-title">Wayo Coach frente a Harbiz</h2>
          <p className="section-subtitle">La referencia del sector en España, comparada punto por punto. Precios de su web, consultados en octubre de 2026.</p>
        </div>
        <div className="compare-table">
          <div className="compare-row compare-header-row">
            <div className="compare-cell">Funcionalidad</div>
            <div className="compare-cell">Harbiz</div>
            <div className="compare-cell">Wayo</div>
          </div>
          {comparisons.map((item, index) => (
            <div key={index} className="compare-row">
              <div className="compare-cell">{item.feature}</div>
              <div className="compare-cell">{item.other}</div>
              <div className="compare-cell">
                {item.feature === "Precio para el profesional" ? (
                  <span className="compare-free-badge">{item.wayo}</span>
                ) : (
                  item.wayo
                )}
              </div>
            </div>
          ))}
        </div>
        <p className="compare-mas">
          <Link to="/alternativa-harbiz">Ver la comparativa completa con Harbiz →</Link>
        </p>
      </div>
    </section>
  );
}
